import type { PatchRelease } from "../types";

export const release: PatchRelease = {
  id: "2026-06-07_02",
  version: "2026.06.07",
  date: "7 Jun 2026",
  sinceCommit: "919ae56",
  gameplay: [],
  skills: [
    {
      spellId: "gravity",
      changes: [
        {
          passiveId: "gravity_null_sphere",
          text: "New synergy **Null Sphere**: Black Hole becomes a null sphere you can place on the arena (**900** cast range vs **320**). It no longer pulls players — but instead pulls and absorbs projectiles. Every shot in the zone (yours, allies', and enemies') spirals to the core and is swallowed. On collapse, each absorbed spell erupts **3x times** in random directions over **3s**. Erupted shots are owned by the void and hit anyone — caster, teammates, and enemies.",
        },
      ],
    },
  ],
};
